module.exports = __webpack_public_path__ + "img/edit.f1237628.svg";